import { useCurrentTimeOfDay } from '@/components/greetings/use-current-time-of-day';
import { useCurrentUser } from '@/user/use-current-user.query';
import { useTranslation } from 'react-i18next';

export const Greetings = () => {
  const { t: greetings } = useTranslation('homepage', {
    keyPrefix: 'greetings',
  });
  const { currentTimeOfDay } = useCurrentTimeOfDay();
  const { data: user } = useCurrentUser();
  const userName = user?.firstName ?? '';

  return (
    <>
      {greetings(currentTimeOfDay, {
        name: userName,
      })}
    </>
  );
};
